export default {
  Arkansas: "a40cebdd-c763-f5e8-d99c-d6725aaec460",
  Louisiana: "e446e61a-193c-8c35-e171-68f0b0d533d7",
  Mississippi: "81a07b34-4fb3-6511-5902-2e8bf5efa66a",
  Texas: "15b28e32-a97b-acb7-d21a-3d94d615265f",
  Other: "03661e66-7fa6-f92d-e97e-53df57ab0e8f"
};
